module.exports = __webpack_public_path__ + "img/step8-b.8494dc8b.png";